
import { AuthScope, useAuthScopes } from '@/lib/useAuthScopes';
import { Component, Vue } from 'vue-property-decorator';
import { userWebserviceV2 } from '@/webservices/v2/user';
import { goToCurrent } from '@/helpers/routing/links';

const { activeScope, scopes, setActiveScope, setScopes } = useAuthScopes();

@Component({
    name: 'UserScopeSelect',
    components: {},
})
export default class UserScopeSelect extends Vue {
    public loading = false;

    private mounted() {
        this.loading = true;
        userWebserviceV2.getCompanies().then((response) => {
            setScopes(response.data.data);
            this.loading = false;
        });
    }

    private async setActiveScope(scope: AuthScope) {
        let hasChanged = false;

        if (activeScope.value !== scope) {
            hasChanged = true;
        }

        await setActiveScope(scope);

        if (hasChanged) {
            this.$store.commit('project/setSelectedProject', undefined);
            goToCurrent('');
            location.reload();
        }
    }

    private humanReadableRoleName(name: string) {
        switch (name) {
            case 'admin':
                return 'Administrator';
            case 'user':
                return 'User';
            default:
                return name;
        }
    }

    private limitedCompanyName(name: string): string {
        return name.length > 15 ? name.substring(0, 15) + '...' : name;
    }

    get scopes() {
        return scopes.value;
    }

    get activeScope() {
        return activeScope.value;
    }

    get sortedScopes() {
        if (!scopes.value) {
            return [];
        }

        return scopes.value.sort((a, b) =>
            a && a.company && b && b.company ? a.company.name.localeCompare(b.company.name) : 0
        );
    }
}
